// A whitespace-only value passes RHF's native `required` check but fails the backend's
// FluentValidation NotEmpty() rule, so required fields must trim before checking emptiness.
export function isRequiredValueMissing(value: unknown): boolean {
  return typeof value === 'string' ? value.trim().length === 0 : !value;
}
